import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import YouTubeButton from './YouTubeButton';
import Footer from './Footer';
import "./Artisti.css";
import { db } from './firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import NavBar from './NavBar';
// Import legal pages
// Legal routes are handled in App.js
export default function PublicSite() {
  const promoRef = useRef(null);
  const [homeVideoUrl, setHomeVideoUrl] = useState('');

  // Load Home video URL from Firestore site config (real-time)
  useEffect(() => {
    try {
      const unsub = onSnapshot(doc(db, 'site', 'config'), (snap) => {
        const data = snap.exists() ? snap.data() : {};
        const url = data?.homeVideoUrl || '';
        setHomeVideoUrl(url);
      });
      return () => unsub();
    } catch (e) {
      // non-blocking
      // console.warn('Impossibile caricare homeVideoUrl', e);
    }
  }, []);

  // Autoplay muted; on first user interaction anywhere, try to unmute + play
  useEffect(() => {
    const v = promoRef.current;
    if (!v) return;
    try {
      v.muted = true;
      const p = v.play?.();
      if (p && typeof p.catch === 'function') {
        p.catch(() => {});
      }
    } catch {}
    const handler = () => {
      try {
        v.muted = false; v.volume = 1;
        const p = v.play?.();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {});
        }
      } catch {}
      window.removeEventListener('click', handler);
      window.removeEventListener('touchstart', handler);
    };
    window.addEventListener('click', handler, { once: true });
    window.addEventListener('touchstart', handler, { once: true });
    return () => {
      window.removeEventListener('click', handler);
      window.removeEventListener('touchstart', handler);
    };
  }, []);
  return (
    <>
      <Link to="/login" className="dash-badge">Dashboard</Link>
  <div className="publicsite-bg page-home">
      <div className="logo-wrapper">
        <div className="logo-stack">
          <img src="/disco.png" alt="Disco" className="disco-img" />
          <img src="/logo.png" alt="Logo Arte Registrazioni" className="logo-img" />
        </div>
      </div>
      <NavBar />
      <div className="container" style={{ flexDirection: "column", alignItems: "center", justifyContent: "center", display: "flex", marginBottom: 0 }}>
        <video ref={promoRef} src={homeVideoUrl || "/monitor-default.mp4"} autoPlay controls loop muted playsInline
          style={{ maxWidth: "92vw", maxHeight: "72vh", borderRadius: 12, boxShadow: "0 4px 24px rgba(0,0,0,0.2)", marginBottom: 12 }}
        />
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link to="/studio" className="glow-btn" style={{ fontSize: "1.4rem", padding: "12px 32px" }}>
            <h1 style={{ fontSize: "1.3em", margin: 0 }}>Arte Registrazioni</h1>
          </Link>
        </div>
      </div>
      <h1 className="publicsite-title">Benvenuto su Arte Registrazioni</h1>
      <p className="publicsite-desc">
        Scopri i nostri artisti, ascolta la loro musica e vivi l'esperienza unica di Arte Registrazioni.<br />
        Utilizza il menu per navigare tra le pagine e accedere a tutte le funzionalità.
      </p>
      </div>
      {/* Simple in-page route mounting if needed */}
      {/* Note: If routing is handled in App.js, these can remain unused. */}
      {/* <Routes>
        <Route path="/termini" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/licenza" element={<Licenza />} />
      </Routes> */}
      <div className="youtube-under-menu">
        <YouTubeButton small layout="row" />
      </div>
      <Footer />
    </>
  );
}
